<template>
  <div>
    <span class="ml-5">
      <vs-dropdown vs-trigger-click>
        <a class="pt-2">
          <img src="@/assets/more.svg" class="max-h-full" alt="" />
          <!-- {{ params.value.name }}
          <vs-icon class="" icon="expand_more"> </vs-icon> -->
        </a>
        <vs-dropdown-menu @click="openDropdown" class="mx-2 w-max">
          <vs-dropdown-item
            v-for="(item, index) in choice"
            :key="index"
            @click="gotoSomething(item)"
          >
            <div class="flex">
              <img
                src="@/assets/mail.svg"
                class="pr-2"
                v-if="item.menu_type === 'Email'"
              />
              <img
                src="@/assets/pencil.svg"
                class="pr-2"
                v-if="item.menu_type === 'Invoice' || item.menu_type === 'Edit'"
              />
              <img
                src="@/assets/add-file.svg"
                class="pr-2"
                v-if="item.menu_type === 'Document'"
              />
              <img
                src="@/assets/download.svg"
                class="pr-2"
                v-if="item.menu_type === 'Download'"
              />
              <img
                src="@/assets/delete.svg"
                class="pr-2"
                v-if="item.menu_type === 'Delete'"
              />
              <img
                src="@/assets/people-fill.svg"
                class="pr-2"
                v-if="item.menu_type === 'Role'"
              />
              <img
                src="@/assets/link-45deg.svg"
                class="pr-2"
                v-if="item.menu_type === 'Link'"
              />
              <img
                src="@/assets/topup_icon.svg"
                class="pr-2"
                v-if="item.menu_type === 'Topup'"
              />
              <p>{{ item.name }}</p>
            </div>
          </vs-dropdown-item>
        </vs-dropdown-menu>
        <!-- <vs-dropdown-menu v-if="nowPage == 'User Management'">
          <vs-dropdown-item>
            Publish
          </vs-dropdown-item>
          <vs-dropdown-item>
            Banned
          </vs-dropdown-item>
        </vs-dropdown-menu> -->
      </vs-dropdown>
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import baseUrl from "../../../../util/backend.js";
export default {
  emits: ["delete-modal"],
  data() {
    return {
      choice: null,
    };
  },
  mounted() {
    // console.log("params more", this.params.value);
    this.choice = this.params.value;
  },
  methods: {
    openDropdown() {
      console.log("params", this.params.data.choice);
    },
    changeStatus(data) {
      console.log(`${this.params.data.name}เปลี่ยนstatusเป็น${data}`);
    },
    async gotoSomething(item) {
      console.log(item);
      console.log(this.params);
      if (this.$route.path.includes("task")) {
        if (item.menu_type === "Edit") {
          this.$router.push(`createtask/${item.value}`);
        }
        if (item.menu_type === "Delete") {
          this.$root.$emit("delete-modal", item.value);
          // const res = await axios.post(
          //   `${baseUrl}/task/delete?task_id=${item.value}`
          // );
          // console.log(res);
          // let month = this.$store.getters["create/getTaskMonth"];
          // let year = this.$store.getters["create/getTaskYear"];
          // this.$store.dispatch("general/getFilteredTaskTable", {
          //   path: "second",
          //   month: month,
          //   year: year,
          // });
        }
      }
      if (this.$route.path.includes("invoice")) {
        if (item.menu_type === "Email") {
          this.$router.push(`/email/invoice/${item.value}`);
        }
        if (item.menu_type === "Invoice") {
          this.$router.push("/editinvoice/" + item.value);
        }
        if (item.menu_type === "Document") {
          this.$router.push("/editinvoice/" + item.value);
        }
        if (item.menu_type === "Download") {
          this.$root.$emit("download-invoice", item.value);
        }
        if (item.menu_type === "Delete") {
          this.$root.$emit("delete-modal", item.value);
        }
      }
      if (this.$route.path.includes("receipt")) {
        if (item.menu_type === "Email") {
          this.$router.push(`/email/receipt/${item.value}`);
        }
        if (item.menu_type === "Edit") {
          this.$router.push(`/editreceipt/${item.value}`);
        }
        if (item.menu_type === "Document") {
          this.$router.push(`/editreceipt/${item.value}`);
        }
        if (item.menu_type === "Download") {
          this.$root.$emit("download-receipt", item.value);
        }
        if (item.menu_type === "Delete") {
          this.$root.$emit("delete-modal", item.value);
        }
      }
      if (this.$route.path === "/managemember") {
        if (item.menu_type === "Topup") {
          this.$router.push(`/topup/${item.value}`);
        }
        if (item.menu_type === "Document") {
          this.$router.push(`/foldermanagement/${item.value}`);
        }
        if (item.menu_type === "Role") {
          this.$root.$emit("show-table", {
            id: item.value,
            company: this.params.data.company_name,
          });
        }
        if (item.menu_type === "Link") {
          let input = document.body.appendChild(
            document.createElement("input")
          );
          input.value = location.protocol + "//" + location.host;
          input.focus();
          input.select();
          document.execCommand("copy");
          input.parentNode.removeChild(input);
          alert("คัดลอกสำเร็จ");
        }
        if (item.menu_type === "Delete") {
          this.$root.$emit("delete-modal", item.value);
        }
      }
      if (this.$route.path.includes("/foldermanagement")) {
        if (item.menu_type === "Role") {
          this.$root.$emit("show-file", {
            id: item.value,
            folderName: this.params.data.name,
            type: this.params.data.type,
          });
        }
        if (item.menu_type === "Delete") {
          let rowData = this.params.data;
          if (
            rowData.type === "Folder" &&
            rowData.folder_level_id === 3 &&
            (rowData.name === "invoice" || rowData.name === "receipt")
          ) {
            alert(`ไม่สามารถลบโฟลเดอร์${rowData.name}ได้`);
            return;
          }
          this.$root.$emit("delete-modal", {
            id: item.value,
            type: this.params.data.type,
          });
        }
      }
      if (this.$route.path.includes("accounting")) {
        if (item.menu_type === "Edit") {
          this.$router.push(`/createaccounting/${item.value}`);
        }
        if (item.menu_type === "Delete") {
          this.$root.$emit("delete-modal", item.value);
          // const res = await axios.post(
          //   `${baseUrl}/accounting/delete?accounting_id=${item.value}`
          // );
          // console.log(res);
          // this.$store.dispatch("general/getTable", "seventh");
        }
      }
      if (this.$route.path.includes("bankpayment")) {
        if (item.menu_type === "Edit") {
          this.$router.push(`/createbankpayment/${item.value}`);
        }
        if (item.menu_type === "Delete") {
          this.$root.$emit("delete-modal", item.value);
          // const res = await axios.post(
          //   `${baseUrl}/bankpayment/delete/?bankpayment_id=${item.value}`
          // );
          // console.log(res);
          // this.$store.dispatch("general/getTable", "eighth");
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      nowPage: "getNowPage",
    }),
  },
};
</script>

<style scoped>
p {
  white-space: nowrap;
}
</style>
